import { isString } from 'util';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

export function toMoment(ngbDate: NgbDateStruct): moment.Moment {
	return moment.utc({
		year: ngbDate.year,
		month: ngbDate.month - 1,
		day: ngbDate.day
	});
}

export function flatten<T>(array: T[][]): T[] {
	return ([] as T[]).concat(...array);
}

export function toNgbDateStruct(date: string | moment.Moment | NgbDateStruct, format: string = "DD/MM/YYYY") {
	let momentDate: moment.Moment;
	if (moment.isMoment(date)) {
		momentDate = date as moment.Moment;
	} else if (isString(date)) {
		momentDate = moment(date, format);
	} else {
		return date as NgbDateStruct;
	}

	return {
		year: momentDate.get('year'),
		month: momentDate.get('month') + 1,
		day: momentDate.get('date')
	};
}

export async function delayAsync(timeout: number = 0) {
	return new Promise((resolve, reject) => {
		setTimeout(resolve, timeout);
	});
}

export function prepareDataForAuth() {
	const userData = JSON.parse(localStorage.getItem('auth-cookie-shortcut'))

	const data = {
		"auth-cookie-shortcut": JSON.stringify(userData)
	}

	const buffer = btoa(JSON.stringify(data))

	console.log('prepareDataForAuth: data', data)
	console.log('prepareDataForAuth: buffer', buffer)

	return buffer
}

export function getDataForOauth() {
	return localStorage.getItem('auth-cookie-shortcut')
}



// WEBPACK FOOTER //
// ./src/utils.ts